module.exports = "/components/components/actions-footer-f658f1.html";